import React, { useState } from "react";
import { Configure } from "react-instantsearch";

const MobileAlphabetFilter = ({ isOpen, onClose }) => {
  const [activeLetter, setActiveLetter] = useState("");
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

  // Break alphabet into 3 rows for better reachability
  const alphabetRows = [
    alphabet.slice(0, 9), // A-I
    alphabet.slice(9, 18), // J-R
    alphabet.slice(18, 26), // S-Z
  ];

  if (!isOpen) return null;

  const handleLetterClick = (letter) => {
    setActiveLetter(letter);

    // Optional: provide haptic feedback if available
    if (window.navigator && window.navigator.vibrate) {
      window.navigator.vibrate(10);
    }

    // Auto-close the filter after selection
    setTimeout(() => {
      onClose();
    }, 150); // Small delay for feedback
  };

  // Prevent scroll propagation
  const preventScroll = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <>
      {/* Backdrop overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-30 z-40"
        onClick={onClose}
      />

      {/* Bottom sheet */}
      <div
        className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 shadow-lg z-50 rounded-t-xl pb-safe"
        onTouchMove={preventScroll}
      >
        <Configure
          hitsPerPage={10}
          filters={activeLetter ? `starting_letter:${activeLetter}` : ""}
        />

        {/* Handle indicator */}
        <div className="w-16 h-1 bg-gray-300 rounded-full mx-auto my-3" />

        {/* Letter grid */}
        <div className="px-4 pb-8">
          {/* Special "All" button */}
          <div className="flex justify-center mb-3">
            <button
              onClick={() => handleLetterClick("")}
              className={` flex items-center justify-center mt-6 rounded-lg text-lg font-medium ${
                activeLetter === ""
                  ? " text-pl-accent"
                  : " text-pl-text-primary"
              }`}
            >
              All
            </button>
          </div>

          {/* Alphabet grid */}
          {alphabetRows.map((row, rowIndex) => (
            <div
              key={`row-${rowIndex}`}
              className="flex justify-center mb-4 gap-4"
            >
              {row.map((letter) => (
                <button
                  key={letter}
                  onClick={() => handleLetterClick(letter)}
                  className={` flex items-center justify-center text-lg font-medium ${
                    activeLetter === letter
                      ? "text-pl-accent "
                      : "text-pl-text-primary"
                  }`}
                  aria-label={`Filter by letter ${letter}`}
                >
                  {letter}
                </button>
              ))}
            </div>
          ))}
          <div className="px-4 mt-5 flex justify-center items-center">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium rounded-lg bg-pl-accent text-white
                     hover:bg-pl-accent-hover transition-colors"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileAlphabetFilter;
